export default __webpack_public_path__ + "static/media/image17.9c0ad1fc.jpg";